import {useEffect, useState} from "react";
import {ViewState} from "../states";
import {get, post} from "../core/request";
import {Card, message, notification, Result} from "antd";
import {CustomButton} from "./buttons";
import TextArea from "antd/es/input/TextArea";
import Loading from "./loading";
import {v4 as get_uuid} from "uuid";

interface FileStoreConfigProps {
    path: string,
    rows: number,
}

export default function FileStoreConfigCard(props: FileStoreConfigProps) {
    const [data, setData] = useState({} as JSON);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState(" ");
    const [state, setState] = useState(ViewState.loading);


    useEffect(() => {
        get(props.path).done((response) => {
                setData(response.data.data);
                if (response.data.title !== undefined) {
                    setTitle(response.data.title);
                }
                if (response.data.description !== undefined) {
                    setDescription(response.data.description);
                }
                setState(ViewState.success);
            }
        ).fail(() => setState(ViewState.failed))
    }, [])

    const tabs = state === ViewState.success ? (
        <Card title={title} extra={
            <CustomButton
                mode={"save"}
                // @ts-ignore
                onClick={
                    () => {
                        try {
                            // @ts-ignore
                            let data = JSON.parse(document.getElementById("dataJSON" + props.path)?.value);

                            let uuid = get_uuid()
                            console.log(uuid)
                            message.loading({
                                content: "Speichere...",
                                key: uuid,
                                duration: 0,
                            });
                            post(props.path, data)
                                .then(
                                    (res) => {
                                        message.destroy(uuid);
                                        let message_config   = {
                                                message: "Erfolgreich gespeichert!",
                                                description: null,
                                                duration: 3,
                                            }

                                        if (res.data.message !== undefined) {
                                            message_config["description"] = res.data.message
                                        }

                                        notification.success(
                                            message_config
                                        )

                                    },
                                    () => {
                                        message.destroy(uuid);
                                        notification.error(
                                            {
                                                message: "Fehler beim Speichern!",
                                                description: "Die Daten konnten nicht gespeichert werden. Bitte versuche es erneut.",
                                                duration: 5,
                                            }
                                        )
                                    }
                                )
                        } catch (e) {
                            notification.error(
                                {
                                    message: "Fehler beim Speichern!",
                                    description: "Die eingegebenen Daten sind ungültig. Bitte überprüfe die Syntax.",
                                    duration: 10,
                                }
                            )
                        }
                    }
                }
            />
        }
              bodyStyle={{
                  paddingTop: 10,
              }}
        >
            {description ? description.split("\n").map(
                (line, index) => <p key={index}>{line}</p>
            ) : <></>}
            <TextArea
                id={"dataJSON" + props.path}
                contentEditable
                rows={props.rows}
                defaultValue={JSON.stringify(data, null, 4)}/>
        </Card>
    ) : (<></>)

    switch (state) {
        case ViewState.loading:
            return (
                <>
                    <Card>
                        <Loading/>
                    </Card>
                </>
            )
        case ViewState.success:
            return (
                <>
                    {tabs}
                </>
            )

        case ViewState.failed:
        default:
            return (
                <>
                    <Card>
                        <Result
                            status="500"
                            title="Etwas hat nicht funktioniert"
                            subTitle="Entschuldigung, es ist ein unerwarteter Fehler aufgetreten!"
                        />
                    </Card>
                </>
            )
    }
}

FileStoreConfigCard.defaultProps = {
    rows: 12,
}